import { useQuery } from "@tanstack/react-query";
import {
  fetchHomepageConfig,
  fetchPodcastEpisodes,
  fetchFeatureModules,
  type SanityHomepageConfig,
  type SanityPodcastEpisode,
  type SanityFeatureModule,
} from "@/lib/sanityQueries";
import { sanityToArticle } from "@/hooks/useSanityArticles";
import type { Article } from "@/components/NewsSection";

export function useHomepageConfig() {
  return useQuery({
    queryKey: ["homepage-config"],
    queryFn: fetchHomepageConfig,
    staleTime: 5 * 60 * 1000,
    structuralSharing: true,
  });
}

export function usePodcastEpisodes() {
  return useQuery({
    queryKey: ["podcast-episodes"],
    queryFn: fetchPodcastEpisodes,
    staleTime: 5 * 60 * 1000,
    structuralSharing: true,
  });
}

export function useFeatureModules() {
  return useQuery({
    queryKey: ["feature-modules"],
    queryFn: fetchFeatureModules,
    staleTime: 5 * 60 * 1000,
    structuralSharing: true,
  });
}

/** Convert pinned Sanity articles to the Article format used throughout the app */
export function usePinnedStories(config: SanityHomepageConfig | null | undefined): Article[] {
  if (!config?.pinnedStories?.length) return [];
  return config.pinnedStories.map(sanityToArticle);
}
